import { useQuery } from "@apollo/client";
import { SALES_ARGUMENTS } from "../sales-argument.queries";
import { SalesArgumentsQuery } from "../../../__generated__/SalesArgumentsQuery";

export const useSalesArguments = () => {
  return useQuery<SalesArgumentsQuery>(SALES_ARGUMENTS);
};
